module.exports = __webpack_public_path__ + "img/domain.507924e7.jpg";